/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */

    /* Module special vocabulary */
    'payment-methods': {
        menu: {
            index: 'روش‌های پرداخت',
            incoming: 'ورودی',
            outgoing: 'خروجی',
        },
        incoming: {
            create: 'روش پرداخت ورودی جدید',
            edit: 'ویرایش روش پرداخت',
            table_titles: {
                id: 'شناسه',
                pay_id: 'PayID',
                country: 'کشور',
                method: 'روش پرداخت',
                page_template: 'قالب',
                instructions: 'دستورالعمل‌ها',
                description: 'توضیحات',
                transaction_fee: 'کارمزد تراکنش',
                processing_time: 'زمان پردازش',
                is_default: 'روش پیش‌فرض؟',
                is_public: 'روش عمومی؟',
                is_fast: 'روش سریع؟',
                setting: 'ویرایش / حذف',
            }
        },
        outgoing: {
            create: 'روش پرداخت خروجی جدید',
            edit: 'ویرایش روش پرداخت',
            table_titles: {
                id: 'شناسه',
                country: 'کشور',
                type: 'نوع',
                instructions: 'دستورالعمل‌ها',
                bank_required: 'باید متعلق به بانک باشد؟',
                info_label1: 'برچسب ۱',
                info_label2: 'برچسب ۲',
                is_default: 'روش پیش‌فرض؟',
                setting: 'ویرایش / حذف',
            }
        },
        templates: {
            address: 'آدرس',
            amount_to_pay: 'مبلغ واریز',
            account_name_copied: 'نام صاحب حساب کپی شد!',
            amount_copied: 'مبلغ کپی شد!',
            important_payment_instructions: 'آنچه که باید در هنگام واریز توجه کنید',
            network: 'شبکه',
            fantastic: 'بسیار عالی',
            our_system_gets_updated_as_soon_as_we_receive_the_payment_at_our_end: 'پس از اینکه واریز شما را دریافت کردیم، سیستم ما فوراً به روز خواهد شد.',
            please_pay_the_exact_amount_do_not_round_this_up_down: 'لطفاً مبلغ را دقیقاً مطابق با مقدار درج شده و بدون گرد کردن واریز نمایید.',
            bank: 'بانک',
            name: 'نام',
            account_name: 'نام صاحب حساب',
            notes: 'یادداشت',
            remarks: 'Remarks',
            account_number: 'شماره حساب',
            iban: 'شماره شبا',
            pay_id: 'ID',
            card_number: 'شماره کارت',
            leave_blank: 'خالی بگذارید'
        }
    }
}

